import { makeAutoObservable } from 'mobx';
import { Checkbox, MessageBar, Pivot, PivotItem, PrimaryButton, Stack, StackItem, TextField } from '@fluentui/react';
import { observer } from 'mobx-react';
import { EntityAPI, IEntityTypeDefinitionProps } from '../../../API';
import { IUserConfigPackage } from '../../../API';
import { TemplatesState } from '../templates/Templates';
import { useEffect } from 'react';

export class EntityTypeTestDialogState {

	async ensureLoaded() {
		let templatesState = new TemplatesState(this.userConfig);
		await templatesState.load();
	}
	
	public entityType:IEntityTypeDefinitionProps;

	public itemId:string = '';
	userConfig: IUserConfigPackage;
	templateName: string = '';
	templateUrl:string = '';
	includeSharePointIfTeams: boolean = true;
	includeFiles: boolean = false;
	includeListItems: boolean = false;
	syncSubmitted: boolean;
	applyTemplateSubmitted: boolean;


	constructor(
		entityType:IEntityTypeDefinitionProps,
		userConfig:IUserConfigPackage,
	) {
		this.entityType = entityType;
		this.userConfig = userConfig;
		this.syncSubmitted = false;
		this.applyTemplateSubmitted = false;

		makeAutoObservable(this);
	}
	
	public setEntityTypeId(id: string) {
		this.entityType.Id = id;
	}

	public setTemplateUrl(arg0: string) {
		this.templateUrl = arg0;
		this.applyTemplateSubmitted = false;
	}

	public setIncludeSharePointIfTeams(arg0: boolean) {
		this.includeSharePointIfTeams = arg0;
	}

	public setIncludeFiles(arg0: boolean) {
		this.includeFiles = arg0;
		this.applyTemplateSubmitted = false;
	}

	public setIncludeListItems(arg0: boolean) {
		this.includeListItems = arg0;
		this.applyTemplateSubmitted = false;
	}
	public setItemId(itemId:string) {
		this.itemId = itemId;
		this.syncSubmitted = false;
		this.applyTemplateSubmitted = false;
	}
	
	public async submitSync() {
		let token = await this.userConfig.getToken();
		let api = EntityAPI.fromEntityTypeId(this.entityType.Id, token);
		this.syncSubmitted = true;
		await api.syncWorkspace(this.itemId);
	}
	
	public async submitApplyTemplate() {
		this.applyTemplateSubmitted = true;
		let token = await this.userConfig.getToken();
		let api = EntityAPI.fromEntityTypeId(this.entityType.Id, token);
		await api.applyTemplate(this.itemId, this.templateUrl || '', this.includeSharePointIfTeams, this.includeFiles, this.includeListItems);
	}
}

function EntityTypeTestDialog({
	state
}: {
	state: EntityTypeTestDialogState;
}) {

	useEffect(() => {
		state.ensureLoaded();
	}, [state]);

	
	return (
		<>
				<Pivot>

					<PivotItem headerText='Sync'>
						
						<MessageBar>A sync request will immediately process the workspace to match your configuration.</MessageBar>
						<Stack>
							<StackItem>
								<TextField label='Item ID' key={'itemid'} onChange={(_,v) => { state.setItemId(v || '') }} />
							</StackItem>
							<StackItem>
								<PrimaryButton style={{paddingTop:5}} text={'Submit Sync Request'}
									iconProps={{
										iconName: 'Save',
									}}
									onClick={(ev) => {
										state.submitSync();
									}}
									disabled={!state.itemId || state.syncSubmitted} />
							</StackItem>
						</Stack>
					</PivotItem>
					
					<PivotItem headerText='Apply template'>
						<Stack>
							<MessageBar>Select a template to apply. This will apply it on top of existing content without affecting any existing data.</MessageBar>
								<TextField label='Item ID' key={'itemid'} onChange={(_,v) => { state.setItemId(v || '') }} />
								
								<TextField label='Template (content URL or PnP file)' value={state.templateUrl} onChange={(_,v) => { state.setTemplateUrl(v || '') }} />

								<Checkbox label='Include SharePoint site if applying a Teams template' checked={state.includeSharePointIfTeams} onChange={(_,v) => { state.setIncludeSharePointIfTeams(!!v) }} />
								<Checkbox label='Include Files' checked={state.includeFiles} onChange={(_,v) => { state.setIncludeFiles(!!v) }} />
								<Checkbox label='Include List Items' checked={state.includeListItems} onChange={(_,v) => { state.setIncludeListItems(!!v) }} />
								<PrimaryButton text={'Submit Apply Template Request'}
									iconProps={{
										iconName: 'Save',
									}}
									onClick={(ev) => {
										state.submitApplyTemplate();
									}}
									disabled={!state.templateUrl || state.applyTemplateSubmitted} 
								/>
						</Stack>
					</PivotItem>

				</Pivot>
				
		</>
	);
}

export default observer(EntityTypeTestDialog);
